// Subset of ReportPurchaseOrderLineItemColumnName from ReportingService

export enum PurchaseOrderLineItemReportTableGroupingColumnId {
  PurchaseOrderLineItemId = 'purchaseOrderLineItemId',
  PurchaseOrderId = 'purchaseOrderId',
  CurrencyCode = 'currencyCode',
  PurchaseOrderDate = 'purchaseOrderDate',
  BuyerUserId = 'buyerUserId',
  PurchaseOrderVendorName = 'purchaseOrderVendorName',
  OrderId = 'orderId',
  VendorAccountEmail = 'encryptedEmailAddress',
  PurchaseOrderState = 'purchaseOrderState',
  PurchasePaymentStatusName = 'purchasePaymentStatusName',
  PurchaseCancellationDate = 'purchaseCancellationDate',
  CostMonth = 'costMonth',
  CostWeek = 'costWeek',
  CostDay = 'costDay',
}

export enum PurchaseOrderLineItemReportTableValueColumnId {
  Tax = 'tax',
  Shipping = 'shipping',
  CreditCardFee = 'creditCardFee',
  BulkDiscount = 'bulkDiscount',
  Cancelled = 'cancelled',
}

export const PURCHASE_ORDER_LINE_ITEM_REPORT_TABLE_FORMULA_COLUMNS: PurchaseOrderLineItemReportTableValueColumnId[] =
  Object.values(PurchaseOrderLineItemReportTableValueColumnId);
